// extracted by mini-css-extract-plugin
export default {"item":"Tab_item__-3SB7","anchor":"Tab_anchor__LNxae","anchorNoWrap":"Tab_anchorNoWrap__-xPv2","ripple":"Tab_ripple__XekO1"};